export class NoSessionTokensError extends Error {
  constructor() {
    super('No session tokens are available. The user is not signed in.');
    this.name = 'NoSessionTokensError';
  }
}

/**
 * Replaces DataRetrievalError. Carries the operation name so a message can say
 * what failed ("retrieving funds"), a stable code for branching, and the HTTP
 * status when there was one.
 */
export class ApiError extends Error {
  readonly operation: string;
  readonly code: string;
  readonly status?: number;

  constructor(
    operation: string,
    message: string,
    code: string,
    options: { status?: number; cause?: unknown } = {},
  ) {
    super(message, { cause: options.cause });
    this.name = 'ApiError';
    this.operation = operation;
    this.code = code;
    this.status = options.status;
  }

  /** Message suitable for showing a user, e.g. "Could not load funds. ..." */
  get userMessage(): string {
    return this.message;
  }

  /** True when retrying is pointless because the caller isn't allowed in. */
  get isAuthFailure(): boolean {
    return this.code === 'UNAUTHORIZED' || this.code === 'FORBIDDEN' || this.code === 'NO_SESSION';
  }
}
